import React, { useState, useEffect, useContext } from 'react';
import styles from './Condominium.module.css';

import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import Panel from '../../Components/Panel/Panel';
import PanelListDefault from '../../Components/PanelListDefault/PanelListDefault';
import RemoveIdsNotFound from '../../Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ExecuteAxios from '../../Components/ExecuteAxios/ExecuteAxios';
import ResetVariables from '../../Components/ResetVariables/ResetVariables';
import ApplyAttributes from '../../Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from '../../Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import { AuthContext } from '../../Contexts/auth';
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator';
import { FaList, FaEdit } from 'react-icons/fa';

function Condominium() {
    const [id, setId] = useState(null);
    const [planId, setPlanId] = useState(null);
    const [cpfCnpj, setCpfCnpj] = useState(null);
    const [clientName, setClientName] = useState(null);
    const [city, setCity] = useState(null);
    const [phone, setPhone] = useState(null);
    const [province, setProvince] = useState(null);
    const [state, setCountry] = useState(null);
    const [address, setAddress] = useState(null);
    const [addressNumber, setAddressNumber] = useState(null);
    const [postalCode, setPostalCode] = useState(null);
    const [email, setEmail] = useState(null);
    const [isActive, setIsActive] = useState('S');

    const { validateClientList } = useContext(AuthContext);
    const [condominiumRecords, setCondominiumRecords] = useState(null);
    const [condominiumRecordDetail, setCondominiumRecordDetail] = useState(null);
    const [selectedsCondominiums, setSelectsCondominiums] = useState([]);
    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingPanel, setLoadingPanel] = useState(false);
    const [activeTab, setActiveTab] = useState('list');

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "planId", value: planId, setter: setPlanId },
        { name: "cpfCnpj", value: cpfCnpj, setter: setCpfCnpj, width: '155px' },
        { name: "clientName", value: clientName, setter: setClientName },
        { name: "city", value: city, setter: setCity },
        { name: "phone", value: phone, setter: setPhone },
        { name: "province", value: province, setter: setProvince },
        { name: "state", value: state, setter: setCountry },
        { name: "address", value: address, setter: setAddress, width: '300px' },
        { name: "addressNumber", value: addressNumber, setter: setAddressNumber },
        { name: "postalCode", value: postalCode, setter: setPostalCode },
        { name: "email", value: email, setter: setEmail },
        {
            name: "isActive", value: isActive, setter: setIsActive, defaultValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
    ];

    const isMobile = window.innerWidth <= 786;

    useEffect(() => {
        const fetchData = async () => {
            await getCondominiumDetail(0);
            await getCondominiumGrid();
        };
        fetchData();
    }, []);

    useEffect(() => {
        setDetailRecord(selectedsCondominiums);
    }, [selectedsCondominiums]);

    async function setDetailRecord(selectedsCondominiums) {
        if (selectedsCondominiums && selectedsCondominiums.length === 1) {
            setInserting(false);
            setUpdating(false);
            await getCondominiumDetail(selectedsCondominiums[0]);
        } else {
            setUpdating(false);
            ResetVariables.resetVariables(attributeList);
        }
    }

    async function getCondominiumGrid() {
        const parameters = { isActive: 'S' };
        const response = await ExecuteAxios.api('get', '/client/get-client-active-grid/', { params: parameters });
        setCondominiumRecords(response);
        RemoveIdsNotFound.remove(response, setSelectsCondominiums, selectedsCondominiums);
    }

    async function getCondominiumDetail(id) {
        const parameters = { id };
        const response = await ExecuteAxios.api('get', '/client/get-client-by-id-detail/', { params: parameters });
        setCondominiumRecordDetail(response);
        if (response) {
            ApplyAttributes.applyAttributes(response, attributeList, inserting);
        }
    }

    async function postCondominium() {
        try {
            setLoadingPanel(true);
            const parameters = {
                planId, cpfCnpj, clientName, city, state, address,
                addressNumber, postalCode, email, isActive, province, phone
            };
            return await ExecuteAxios.api('post', '/client/', parameters);
        } finally {
            setLoadingPanel(false);
        }
    }

    async function putCondominium() {
        try {
            setLoadingPanel(true);
            const parameters = {
                id, planId, cpfCnpj, clientName, city, state, address,
                addressNumber, postalCode, email, isActive, province, phone
            };
            return await ExecuteAxios.api('put', '/client/', parameters);
        } finally {
            setLoadingPanel(false);
        }
    }

    const mainPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
    };

    return (
        <LayoutDefault>
            {(activeTab === 'list' || !isMobile) && (
                <Panel
                    className={'main-modal two left'}
                    style={mainPanelStyle}
                    titlePage={'Condomínios'}
                    canViewCRUD={true}
                    recordsSelected={[]}
                    viewOnlyOneRecordCRUD={false}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={condominiumRecords}
                    attributeList={attributeList}
                    onUpdateIdSelected={setSelectsCondominiums}
                >
                    <LoadingIndicator loaded={condominiumRecords && !loadingPanel}>
                        <PanelListDefault
                            onUpdateIdSelected={setSelectsCondominiums}
                            idsSelected={selectedsCondominiums}
                            data={condominiumRecords}
                            attributeList={attributeList}
                            selectFirstRecord={true}
                            inserting={inserting}
                            updating={updating}
                        />
                    </LoadingIndicator>
                </Panel>

            )}
            {(activeTab === 'detail' || !isMobile) && (
                <Panel
                    className={'main-modal two right'}
                    style={mainPanelStyle}
                    titlePage={'Condomínio selecionado'}
                    setUpdating={setUpdating}
                    setInserting={setInserting}
                    inserting={inserting}
                    updating={updating}
                    enableEdit={true}
                    canEdit={selectedsCondominiums && selectedsCondominiums.length === 1}
                    putFunction={putCondominium}
                    enableNewRecord={true}
                    canNewRecord={true}
                    postFunction={postCondominium}
                    canViewCRUD={true}
                    recordsSelected={[]}
                    viewOnlyOneRecordCRUD={false}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={condominiumRecords}
                    attributeList={attributeList}
                    onUpdateIdSelected={setSelectsCondominiums}
                    reloadFilter={
                        async () => {
                            await getCondominiumGrid()
                            await validateClientList()
                        }
                    }
                    cancelFunction={
                        async () => {
                            await setDetailRecord(selectedsCondominiums)
                        }
                    }
                >
                    <LoadingIndicator loaded={condominiumRecordDetail && !loadingPanel}>
                        <AutomaticallyListedAttributes
                            list={condominiumRecordDetail}
                            attributeList={attributeList}
                            readOnlyAttributes={!inserting && !updating}
                        />
                    </LoadingIndicator>
                </Panel>
            )}

            {/* Navegação inferior mobile */}
            {isMobile && (
                <div className={styles.bottomNav}>
                    <button
                        className={`${styles.navButton} ${activeTab === 'list' ? styles.active : ''}`}
                        onClick={() => setActiveTab('list')}
                    >
                        <FaList />
                        <span>Lista</span>
                    </button>
                    <button
                        className={`${styles.navButton} ${activeTab === 'detail' ? styles.active : ''}`}
                        onClick={() => setActiveTab('detail')}
                    >
                        <FaEdit />
                        <span>Detalhe</span>
                    </button>
                </div>
            )}
        </LayoutDefault>
    );
}

export default Condominium;
